import { connect } from 'react-redux';

import OnlyPieReport from '../../Components/Report/OnlyPieReport';
import { resultsToReport } from '../../Store/actions/report';

const mapStateToProps = state => {
    return {
        ...resultsToReport(state.data)
    }
}

export default connect(mapStateToProps)(OnlyPieReport);